var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"chat-frame"},[_c('el-col',{staticClass:"welcome-speech",attrs:{"span":24}},[_vm._v("\n    "+_vm._s(_vm.chatData.greeting)+"\n  ")]),_c('chat-item',{attrs:{"chatData":_vm.chatData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }